import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue"
import { COUNTRIES, ICountry } from "@/constants/data"


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelectV2',
  props: {
    value: null,
    label: null,
    required: { type: Boolean },
    errorMessages: null,
    outlined: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["input", "change"],
  setup(__props: any) {

const props = __props as {
  value?: string | null
  label?: string
  required?: boolean
  errorMessages?: string[]
  outlined?: boolean
  disabled?: boolean
}



const form = ref({
  countryCode: "",
})



const getItemText = (item: ICountry) => `${item.flag} ${item.en}`

onMounted(() => {
  if (props.value) {
    form.value.countryCode = props.value
  }
})

return { __sfc: true,props, form, getItemText, COUNTRIES }
}

})